import React, { useEffect, useRef, useState } from 'react';
import './Navbar.css';

const logo = "/rapidus_logo.png";

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'About', href: '#about' },
  { label: 'Projects', href: '#projects' },
  { label: 'Team', href: '#team' },
  { label: 'Contact', href: '#contact' },
];

const Navbar: React.FC = () => {
  const [activeId, setActiveId] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const drawerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ids = navLinks.map(l => l.href.replace('#', ''));
    const observers: IntersectionObserver[] = [];

    ids.forEach(id => {
      const el = document.getElementById(id);
      if (!el) return;

      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setActiveId(id);
        },
        { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
      );

      obs.observe(el);
      observers.push(obs);
    });

    return () => observers.forEach(o => o.disconnect());
  }, []);

  useEffect(() => {
    if (!menuOpen) return;

    const handler = (e: MouseEvent) => {
      if (drawerRef.current && !drawerRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.getElementById(href.replace('#', ''));
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <nav id="navbar">
        <a className="nav__logo" href="#home" onClick={e => handleScroll(e, '#home')}>
          <img src={logo} alt="Rapidus AI" className="nav__logo-img" />
        </a>

        <ul className="nav__links">
          {navLinks.map(link => (
            <li key={link.label}>
              <a 
                href={link.href}
                className={activeId === link.href.replace('#', '') ? 'active' : ''}
                onClick={e => handleScroll(e, link.href)}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        
<a
  href="#contact"
  className="nav__cta nav__cta--desktop"
  onClick={e => handleScroll(e, '#contact')}
>
  Get Started
</a>

<button
          className={`nav__hamburger ${menuOpen ? 'nav__hamburger--open' : ''}`}
          onClick={() => setMenuOpen(v => !v)}
        >
          <span /><span /><span />
        </button>
      </nav>

      <div
        className={`nav__overlay ${menuOpen ? 'nav__overlay--open' : ''}`}
        onClick={() => setMenuOpen(false)}
      />

      <div
        ref={drawerRef}
        className={`nav__drawer ${menuOpen ? 'nav__drawer--open' : ''}`}
      >
        <div className="nav__drawer-header">
          <img src={logo} alt="Rapidus AI" className="nav__logo-img nav__logo-img--drawer" />
          <button className="nav__drawer-close" onClick={() => setMenuOpen(false)}>&#x2715;</button>
        </div>

        <ul className="nav__drawer-links">
          {navLinks.map(link => (
<li key={link.label}>
  <a
    href={link.href}
    className={activeId === link.href.replace('#', '') ? 'active' : ''}
    onClick={e => handleScroll(e, link.href)}
  >
    {link.label}
    <span className="nav__drawer-arrow">&#8250;</span>
  </a>
</li>
          ))}
        </ul>

        
<a
  href="#contact"
  className="nav__cta nav__cta--drawer"
  onClick={e => handleScroll(e, '#contact')}
>
  Get Started
</a>
      </div>
    </>
  );
};

export default Navbar;